import React from 'react';
import { useIntl } from 'react-intl';
import { Spinner } from '@aibuild/ui';
import type { EntitlementResponse } from '@api/types/entitlements';
import FooterRow from './FooterRow';
import FooterSkillTile from './FooterSkillTile';
import { Note } from './AppsFooter.styled';

interface FooterSkillsContentProps {
  readonly skills: readonly EntitlementResponse[];
  readonly grid: boolean;
  readonly isLoading: boolean;
  readonly isError: boolean;
  readonly onDownload: (skill: EntitlementResponse) => void;
}

const FooterSkillsContent: React.FC<FooterSkillsContentProps> = ({
  skills,
  grid,
  isLoading,
  isError,
  onDownload,
}) => {
  const intl = useIntl();

  if (isLoading) {
    return (
      <Note>
        <Spinner size="sm" />
      </Note>
    );
  }
  if (isError) {
    return (
      <Note role="alert">
        {intl.formatMessage({
          id: 'appsFooter.marketplace.error',
          defaultMessage: 'The marketplace could not be loaded',
        })}
      </Note>
    );
  }
  if (skills.length === 0) {
    return (
      <Note data-testid="apps-footer__empty">
        {intl.formatMessage({ id: 'appsFooter.marketplace.empty', defaultMessage: 'Nothing here yet.' })}
      </Note>
    );
  }

  return (
    <FooterRow
      grid={grid}
      label={intl.formatMessage({ id: 'marketplace.title', defaultMessage: 'Marketplace' })}
    >
      {skills.map((skill) => (
        <FooterSkillTile key={skill.skillId} skill={skill} grow={!grid} onDownload={onDownload} />
      ))}
    </FooterRow>
  );
};

export default FooterSkillsContent;
